import {combineReducers} from 'redux';
import fuse from './fuse';
import auth from 'auth/store/reducers';
import quickPanel from 'main/quickPanel/store/reducers';
import Instrumen from './Instrumen.reducers';
import Sekolah from './Sekolah.reducers';
import Pengguna from './Pengguna.reducers';
import App from './App.reducers';
import RaporMutu from './RaporMutu.reducers';
import Supervisi from './Supervisi.reducers';

const rootReducer = combineReducers({
    auth,
    fuse,
    quickPanel,
    Instrumen,
    Sekolah,
    Pengguna,
    App,
    RaporMutu,
    Supervisi
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js